import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const Y2KTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const s = 3.375;

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #1a0033 0%, #330066 50%, #1a0033 100%)',
        overflow: 'hidden', position: 'relative',
        fontFamily: 'Arial, sans-serif', boxSizing: 'border-box'
      }}
    >
      {/* 網格背景 */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: `linear-gradient(rgba(255,0,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,0,255,0.15) 1px, transparent 1px)`,
        backgroundSize: `${15 * s}px ${15 * s}px`, opacity: 0.4
      }} />

      {/* 霓虹光暈 */}
      <div style={{
        position: 'absolute', top: '15%', left: '50%', transform: 'translateX(-50%)',
        width: `${180 * s}px`, height: `${180 * s}px`, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,0,255,0.3) 0%, transparent 70%)',
        filter: `blur(${30 * s}px)`
      }} />

      {/* 主內容區 */}
      <div style={{
        position: 'relative', zIndex: 10, height: '100%',
        display: 'flex', flexDirection: 'column',
        padding: `${24 * s}px ${20 * s}px ${20 * s}px ${20 * s}px`
      }}>

        {/* 頂部愛心圓圈 */}
        <div style={{ textAlign: 'center', marginBottom: `${14 * s}px` }}>
          <div style={{
            display: 'inline-block', padding: `${9 * s}px`,
            background: 'rgba(0,0,0,0.5)', borderRadius: '50%',
            border: `${2 * s}px solid #ff00ff`,
            boxShadow: `0 0 ${15 * s}px #ff00ff, 0 0 ${30 * s}px rgba(255,0,255,0.4)`
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={`${48 * s}`} height={`${48 * s}`} viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#ff00ff" />
            </svg>
          </div>
        </div>

        {/* 中間內容 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: `${72 * s}px`, fontWeight: '800', color: '#ffffff', lineHeight: '1', marginBottom: `${8 * s}px`, fontFamily: 'Arial, sans-serif', letterSpacing: `${-2 * s}px`, textShadow: `0 0 ${6 * s}px #ff00ff, 0 0 ${12 * s}px #ff00ff, 0 0 ${18 * s}px #ff00ff` }}>
            {calculatedDays}
          </div>
          <div style={{ fontSize: `${16 * s}px`, fontWeight: '600', color: '#00ffff', marginBottom: `${16 * s}px`, textShadow: `0 0 ${6 * s}px #00ffff` }}>
            {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
          </div>
          {detailedTime && (
            <div style={{ fontSize: `${12 * s}px`, color: '#ffffff', fontWeight: '500', marginBottom: `${12 * s}px`, padding: `${6 * s}px ${14 * s}px`, background: 'rgba(0,0,0,0.5)', border: `${1 * s}px solid #ff00ff`, borderRadius: `${20 * s}px`, display: 'inline-block', boxShadow: `0 0 ${10 * s}px rgba(255,0,255,0.3)` }}>
              {formatDetailedTime(detailedTime, language)}
            </div>
          )}
          {quote && (
            <div style={{ fontSize: `${10 * s}px`, color: '#e0e0ff', fontStyle: 'italic', lineHeight: '1.6', paddingLeft: `${16 * s}px`, paddingRight: `${16 * s}px`, textShadow: `0 ${1 * s}px ${3 * s}px rgba(0,0,0,0.8)` }}>
              "{quote}"
            </div>
          )}
        </div>

        {/* 底部信息 */}
        <div style={{ textAlign: 'center', paddingTop: `${14 * s}px` }}>
          <div style={{ width: '100%', height: `${1 * s}px`, background: 'linear-gradient(90deg, transparent, #ff00ff, transparent)', marginBottom: `${10 * s}px` }} />
          {anniversaryDate && (
            <div style={{ fontSize: `${9 * s}px`, color: '#e0e0ff', marginBottom: `${6 * s}px` }}>
              {formatDate(anniversaryDate, language)}
            </div>
          )}
          <div style={{ fontSize: `${10 * s}px`, fontWeight: '700', color: '#ff00ff', textTransform: 'uppercase', letterSpacing: `${1 * s}px`, marginBottom: `${4 * s}px`, textShadow: `0 0 ${6 * s}px #ff00ff` }}>
            {getBrandingText(anniversaryType, language)}
          </div>
          <div style={{ fontSize: `${8 * s}px`, color: '#00ffff', textShadow: `0 0 ${4 * s}px #00ffff` }}>
            lovedays.homy.hk
          </div>
        </div>
      </div>
    </div>
  );
};

export default Y2KTemplate;